import { useEffect, useRef, useState } from 'react';

const useLazy = promise => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(
    () => {
      promise.then(module => {
        ref.current = module.default;
        setLoaded(true);
      });
    },
    [ref, setLoaded, promise]
  );

  return [loaded, ref];
};

export default useLazy;
